import { ESaleType } from '../../../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFlatOldSaleTypeFilter } from 'shared/selectors/advancedFilters';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray } from '../../../../../../../../../packages/JsonQuery';

export const FlatOldSaleTypeContainer: FC = () => {
  const { value, options } = useSelector(selectFlatOldSaleTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleFlatOldSaleTypesChange = useCallback(
    (newValue: NonEmptyArray<ESaleType> | null) => {
      onChange({ action: 'setFlatOldSaleTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleFlatOldSaleTypesChange} />;
};
